import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const ModalContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: ${({ theme: { colors } }) => colors.darken};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled(FlexContainer)`
  position: relative;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 14px;
  width: 200px;
  max-width: 400px;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 30px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    min-width: 90%;
    max-width: 90%;
  }
`;

export const CloseButton = styled.button`
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 15px;
  svg {
    width: 16px;
    height: 16px;
  }
`;
